<template>
  <v-app class="app-tabela">
    <v-card class="tabela">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="input-bottom"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @pagination="getPagination"
        :page="currentPage"
        :footer-props="{
          itemsPerPageText: '',
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        :loading="loading"
        loading-text="Carregando, Por favor espere"
        :headers="headers"
        :items="indexedItems"
        :search="search"
        item-key="index"
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
        @item-expanded="onItemExpanded"
      >
        <template v-slot:item.dt_atendimento="{ item }">
          <td>
            {{
              item.dt_atendimento != null ? formatDate(item.dt_atendimento) : ''
            }}
          </td>
        </template>

        <template v-slot:item.procedimento="{ item }">
          <td>
            {{ item.ds_proced }}
          </td>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td colspan="9">
            <table class="table table-interna table-interna-acompanhamento">
              <thead>
                <tr>
                  <th>CPF</th>
                  <th>CNS</th>
                  <th>Equipe</th>
                  <th>CBO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.nu_cpf_cidadao }}</td>
                  <td>{{ item.nu_cns }}</td>
                  <td>
                    {{ item.nu_ine }}
                    <span
                      v-if="item.no_equipe != null"
                      v-b-tooltip.hover.right
                      :title="item.no_equipe"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.nu_cbo }}
                    <span
                      v-if="item.no_cbo != null"
                      v-b-tooltip.hover.right
                      :title="item.no_cbo"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <b-alert
              v-if="item.duplicadoInfo"
              variant="danger"
              show
              class="mt-2"
            >
              Registro duplicado. Tem outro atendimento na data
              {{ item.duplicadoInfo.data }}
              com esse mesmo Identificador (Id {{ item.duplicadoInfo.id }}).
              Recomenda-se realizar auditoria no Banco de Dados.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'gestante' &&
                item.st_proced == 'Solicitado'
              "
              variant="danger"
              show
              class="mt-4"
            >
              <strong>⚠️ Atenção:</strong> Não basta solicitar o exame. Para que
              ele seja considerado no cuidado à gestante, é necessário avaliar e
              registrar o resultado no sistema. Para mais informações, ver a
              <a
                href="https://www.gov.br/saude/pt-br/composicao/saps/publicacoes/fichas-tecnicas/equipe-de-atencao-primaria-e-saude-da-familia/nota-metodologica-c3-cuidado-na-gestacao-e-puerperio/view"
                target="_blank"
                >Nota Metodológica de Cuidado na Gestação e Puerpério
                <span class="arrow-diagonal">
                  <i class="icofont-long-arrow-up"></i>
                </span>
              </a>
            </b-alert>
          </td>
        </template>

        <template v-slot:[`footer.page-text`]="items">
          <div class="info-table-item tabela-esus-pec">
            <FonteSincronizadorC />
          </div>
          <span class="paginacao"
            >{{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }} registros</span
          >
        </template>

        <template v-slot:no-data>
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
        <template v-slot:no-results style="padding: 0px">
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Exames',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
    cnsList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'ATENDIMENTO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dt_atendimento',
        },
        {
          text: 'SIGTAP',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'co_proced',
        },
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'procedimento',
        },
        {
          text: 'TIPO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'st_proced',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastrosOriginais: [],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    cadastrosFiltrados() {
      const { operador, data, usarFiltroData } = this.filtroAtendimento || {}

      // sem filtro ativo
      if (!usarFiltroData || !data || !operador) {
        return this.cadastros
      }

      return this.cadastros.filter((item) => {
        let dt = item.dt_atendimento
        if (dt == null) return
        const dataItem = dt.split('/').reverse().join('-')
        return this._compareDates(dataItem, data, operador)
      })
    },

    indexedItems() {
      return this.cadastrosFiltrados.map((item, index) => ({
        index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Compara duas datas no formato YYYYMMDD.
     * @param {String} aYmd Primeira data
     * @param {String} bYmd Segunda data
     * @param {String} op Operador de comparação
     * @returns {Boolean}
     */
    _compareDates(aYmd, bYmd, op) {
      if (!aYmd || !bYmd) return true
      switch (op) {
        case '>':
          return aYmd > bYmd
        case '<':
          return aYmd < bYmd
        case '>=':
          return aYmd >= bYmd
        case '<=':
          return aYmd <= bYmd
        case '=':
          return aYmd === bYmd
        default:
          return true
      }
    },

    /**
     * Calcula a diferença em meses entre a data informada e hoje.
     * @param {String} date Data no formato YYYY-MM-DD
     * @returns {Number} Quantidade de meses
     */
    diffMonthsFromDate(date) {
      const [year, month, day] = date.split('-')
      const startDate = new Date(year, month - 1, day)
      let today = new Date()
      let months = (today.getFullYear() - startDate.getFullYear()) * 12
      months -= startDate.getMonth()
      months += today.getMonth()
      return months
    },

    /**
     * Filtra os cadastros pelo período informado.
     * @param {Object|null} periodo Período selecionado
     */
    handlePeriod(periodo) {
      if (periodo == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }
      this.cadastros = this.cadastrosOriginais.filter((item) => {
        let itemDate = item.dt_atendimento
        let monthsDiff = this.diffMonthsFromDate(itemDate)
        return monthsDiff <= periodo.value
      })
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true
        const response2 = await this.$api.post(`/app/cidadao/exames`, {
          co_ibge: this.$store.state.cod_ibge,
          cpf: this.cidadao.nu_cpf,
          cns: this.cnsList,
        })
        if (response2) {
          this.cadastrosOriginais = response2.data
          this.cadastros = response2.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} ctx Contexto do item expandido
     */
    onItemExpanded(ctx) {
      const item = ctx?.item

      if (!item) return

      const duplicados = this.indexedItems.filter((i) => i.id === item.id)
      if (duplicados.length >= 2) {
        this.$set(item, 'duplicadoInfo', {
          data: item.dt_atendimento ? this.formatDate(item.dt_atendimento) : '',
          id: item.id,
        })
      } else {
        this.$delete(item, 'duplicadoInfo')
      }
    },
  },
}
</script>

<style lang="scss">
.arrow-diagonal {
  display: inline-block;
  margin-left: -4px;
}

.arrow-diagonal i {
  display: inline-block;
  transform: rotate(45deg);
}
</style>
